import PropTypes from 'prop-types';
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import Checkbox from '../Checkbox';
import i18n from '../../utils/translate';

import './styles.scss';

const propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })).isRequired,
  multi: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  onWrongLength: PropTypes.func,
  value: PropTypes.any
};
const defaultProps = {
  className: '',
  value: 0
};

class Dropdown extends Component {
  minLengthValid = true;
  maxLengthValid = true;

  state = {
    isOpen: false
  };

  constructor(props) {
    super(props);

    this.state = {
      minLengthError: false,
      maxLengthError: false
    };
  }

  validateValue(value) {
    const { options } = this.props;
    let optionIndex = 0;

    options.forEach((option, index) => {
      if (option.value === value) {
        optionIndex = index;
      }
    });

    return optionIndex;
  }

  label = () => {
    const { options, value, multi } = this.props;

    if (value === null || value === undefined || value.length === 0) return i18n('Bitte auswählen');

    if (multi) {
      const labels = (value || []).map(option => {
        const i = this.validateValue(option);
        return options[i].label;
      });
      return labels.join(', ');
    }
    const i = this.validateValue(value);
    return options[i].label;
  };

  toggleDropdown = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen
    });
  };

  handleClickOutside = e => {
    const { value, onWrongLength } = this.props;
    const { isOpen } = this.state;

    if (isOpen && !this.isValidInput(value) && !!onWrongLength) {
      onWrongLength(this.minLengthValid, this.maxLengthValid);
    }

    this.setState({
      isOpen: false
    });
  };

  isValidInput = (value = []) => {
    const { multi, min, max } = this.props;
    let minLengthError = false;
    let maxLengthError = false;

    if (multi) {
      if (!!min) {
        minLengthError = value.length < min;
      }
      if (!!max) {
        maxLengthError = value.length > min;
      }
      this.setState({ minLengthError, maxLengthError });
      return !minLengthError && !maxLengthError;
    }
    return true;
  };

  onChangeValue = option => {
    const { multi, onChange, value = [] } = this.props;
    const { minLengthError, maxLengthError } = this.state;

    if (multi) {
      let newValue;
      if (this.isSelected(option)) {
        newValue = (value || []).filter(v => v !== option.value);
      } else {
        newValue = [...value, option.value];
      }
      onChange(newValue);

      if (minLengthError || maxLengthError) {
        this.isValidInput(newValue);
      }
    } else {
      onChange(option.value);
      this.setState({ isOpen: false });
    }
  };

  isSelected = option => {
    const { value } = this.props;
    return (value || []).includes(option.value);
  };

  renderOption = option => {
    const { multi } = this.props;

    return (
      <button key={option.label} value={option.value} onClick={() => this.onChangeValue(option)}>
        {multi && (
          <Checkbox
            name={option.value.toString()}
            id={option.value.toString()}
            checked={this.isSelected(option)}
            onChange={() => {}}
            className="multi-select"
          />
        )}
        <span className="option-label">{option.label}</span>
      </button>
    );
  };

  renderMinError = () => {
    const { min } = this.props;
    return min === 1 ? (
      <span className="field-error-message">{i18n(`Es muss mindestens 1 Option ausgewählt werden!`)}</span>
    ) : (
      <span className="field-error-message">{i18n(`Es müssen mindestens ${min} Optionen ausgewählt werden!`)}</span>
    );
  };

  renderMaxError = () => {
    const { max } = this.props;
    return max === 1 ? (
      <span className="field-error-message">{i18n(`Es darf maximal 1 Option ausgewählt werden!`)}</span>
    ) : (
      <span className="field-error-message">{i18n(`Es dürfen maximal ${max} Optionen ausgewählt werden!`)}</span>
    );
  };

  render() {
    const { className, options } = this.props;
    const { isOpen, minLengthError, maxLengthError } = this.state;

    const isError = minLengthError || maxLengthError;

    return (
      <div className={`dropdown-wrapper ${className}`}>
        <div className={`dropbtn ${isError ? 'textfield-error ' : ''}`} onClick={this.toggleDropdown}>
          {this.label()}
          <span className="dropdown-icon" />
        </div>
        <div className="error-sign" />
        {minLengthError && this.renderMinError()}
        {maxLengthError && this.renderMaxError()}
        {isOpen && <div className="dropdown-content">{options.slice(0).map(option => this.renderOption(option))}</div>}
      </div>
    );
  }
}

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

export default onClickOutside(Dropdown);
